import React from 'react';
import Button from '../../common/Button/Button';
import styles from './CooperativePreview.module.css';

function CooperativePreview() {
  return (
    <section className={styles.cooperativeSection}>
      <div className="container">
        <div className={styles.cooperativeContent}>
          <div className={styles.cooperativeImageWrapper}>
            <div className={styles.imageCard}>
              <img src="/images/ossaturebois4.jpg" alt="Notre équipe de la coopérative" className={styles.mainImage} />
              <div className={styles.statBadge}>
                <span className={styles.statNumber}>100%</span>
                <span className={styles.statLabel}>Humain & Local</span>
              </div>
            </div>
            <div className={styles.imageDecoration}></div>
          </div>

          <div className={styles.cooperativeText}>
            <span className={styles.eyebrow}>Modèle Coopératif</span>
            <h2 className={styles.title}>Plus qu'un constructeur, une coopérative</h2>
            <div className={styles.divider}></div>
            <p className={styles.description}>
              Notre statut de SCOP (Société Coopérative et Participative) place l'humain au cœur de notre projet. Chaque membre de l'équipe est un associé engagé pour la réussite de votre maison.
            </p>
            <div className={styles.featureList}>
              <div className={styles.featureItem}>
                <span className={styles.featureDot}></span>
                <span>Transparence Totale</span>
              </div>
              <div className={styles.featureItem}>
                <span className={styles.featureDot}></span>
                <span>Engagement Durable</span>
              </div>
              <div className={styles.featureItem}>
                <span className={styles.featureDot}></span>
                <span>Excellence Artisanale</span>
              </div>
            </div>
            <div className={styles.ctaWrapper}>
              <Button to="/qui-sommes-nous" variant="primary">Découvrir notre coopérative</Button>
            </div>
          </div>
        </div>
      </div>
    </section>

  );
}

export default CooperativePreview;
